export function mapAdminExchangeRate(raw) {
  if (!raw || typeof raw !== 'object') {
    return null
  }

  const fromCurrency = String(raw.from_currency_code ?? raw.fromCurrency ?? '')
    .trim()
    .toLowerCase()
  const toCurrency = String(raw.to_currency_code ?? raw.toCurrency ?? '')
    .trim()
    .toLowerCase()
  const exchangeRate = String(raw.exchange_rate ?? raw.exchangeRate ?? '').trim()

  if (!fromCurrency || !toCurrency || !exchangeRate) {
    return null
  }

  return {
    fromCurrency,
    toCurrency,
    exchangeRate,
    source: String(raw.source ?? '').trim(),
  }
}
